import CloseButton from 'Components/Common/CloseButton'
import { debounce } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Offcanvas, OffcanvasBody } from 'reactstrap'
import { RootState } from 'store'
import { MilestoneCollaborationsFilters, MilestoneCollaborationSortOptionLabel, MilestoneCollaborationSortOptions, MilestoneCollaborationStatus, MilestoneCollaborationStatusLabel, MilestoneStepAssignee, MilestoneStepAssigneeColorCode, MilestoneStepAssigneeLabel } from 'types/collaboration'
import AsyncSelect from 'react-select/async';
import { defaultFiltersValue } from './milestone/Filters'
interface TaskFiltersProps {
    isOpen: boolean,
    onClose: () => void,
    defaultFilters: MilestoneCollaborationsFilters
    onApply: (filters: MilestoneCollaborationsFilters) => void;
}

const TaskFilters: React.FC<TaskFiltersProps> = ({ isOpen, onClose, defaultFilters, onApply }) => {

    const [filters, setFilters] = useState<MilestoneCollaborationsFilters>(defaultFilters);
    const gigTypes = useSelector((state: RootState) => state.collaborations.gigTypes);
    const gigSteps = useSelector((state: RootState) => state.collaborations.gigSteps);

    useEffect(() => {
        setFilters(defaultFilters);
    }, [defaultFilters])

    const handleFilterChange = (key: string, value: MilestoneCollaborationSortOptions | MilestoneCollaborationStatus | string | { label: string, value: string }) => {
        setFilters({ ...filters, [key]: value });
    }

    // const _loadAgenciesSuggestions = (query: string, callback: any) => {
    //     if (!query || query.length < 3) callback([]);

    //     fetchAgencies(query)
    //         .then(resp => callback(resp.map((item: any) => ({ value: item.uuid, label: item.name, id: item.id })))).catch(() => callback([]))
    // };

    // const loadAgenciesSuggestions = debounce(_loadAgenciesSuggestions, 200);

    // const _loadCampaignsSuggestions = (query: string, callback: any, agency_id: any) => {
    //     if (!query || query.length < 3) callback([]);

    //     fetchCampaigns(query, agency_id)
    //         .then(resp => callback(resp.map((item: any) => ({ value: item.id, label: item.name, })))).catch(() => callback([]))
    // };

    // const loadCampaignsSuggestions = debounce((query, callback) => _loadCampaignsSuggestions(query, callback, filters.agency?.id ?? null), 200);

    // const _loadHubsSuggestions = (query: string, callback: any) => {
    //     if (!query || query.length < 3) callback([]);

    //     fetchHubs(query)
    //         .then(resp => callback(resp.map((item: any) => ({ value: item.uuid, label: item.name, id: item.id })))).catch(() => callback([]))
    // };

    // const loadHubsSuggestions = debounce(_loadHubsSuggestions, 200);

    const _loadPendingTasksSuggestions = (query: string, callback: any) => {
        if (!query) callback([]);
        const filteredSteps = gigSteps.filter((step) => step.name.toLowerCase().includes(query.toLowerCase()));
        callback(filteredSteps.map((item: any) => ({ value: item.slug, label: item.name })));
    }

    const loadPendingTasksSuggestions = debounce(_loadPendingTasksSuggestions, 200);


    return (
        <Offcanvas isOpen={isOpen} toggle={onClose} direction='end'>
            <CloseButton top='10px' onClose={onClose} />
            {/* <OffcanvasHeader>Application Filters</OffcanvasHeader> */}
            <OffcanvasBody className='p-0 position-relative'>
                <div className="payments-offcanvas-bg"></div>
                <div className="filters p-4">
                    {/* <div className="form-group filter-item">
                        <span className="filter-title">Agency</span>
                        <AsyncSelect
                            value={typeof filters.agency === 'string' ? null : filters.agency ?? null}
                            onChange={(val) => {
                                setFilters({ ...filters, agency: val ?? null, agency_id: val?.value })
                            }}
                            placeholder="Choose Agency"
                            menuPlacement='top'
                            cacheOptions
                            className=''
                            isClearable
                            loadOptions={loadAgenciesSuggestions}
                        />
                    </div>
                    <div className="form-group filter-item">
                        <span className="filter-title">Campaign</span>
                        <AsyncSelect
                            value={typeof filters.campaign === 'string' ? null : filters.campaign ?? null}
                            onChange={(val) => {
                                setFilters({ ...filters, campaign: val ?? null, campaign_id: val?.value })
                            }}
                            placeholder="Choose Campaign"
                            menuPlacement='top'
                            cacheOptions
                            className=''
                            isClearable
                            loadOptions={loadCampaignsSuggestions}
                        />
                    </div>
                    <div className="form-group filter-item">
                        <span className="filter-title">Hub</span>
                        <AsyncSelect
                            value={typeof filters.hub === 'string' ? null : filters.hub ?? null}
                            onChange={(val) => {
                                setFilters({ ...filters, hub: val ?? null, hub_id: val?.value })
                            }}
                            placeholder="Choose Hub"
                            menuPlacement='top'
                            cacheOptions
                            className=''
                            isClearable
                            loadOptions={loadHubsSuggestions}
                        />
                    </div> */}
                    <div className="form-group filter-item">
                        <span className="filter-title">Status</span>
                        <div className="d-flex  gap-2 justify-content-start align-items-center flex-wrap">
                            {
                                Object.values(MilestoneCollaborationStatus).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('status', filterVal)} className={`filters-badge ${filters.status === filterVal && 'active'}`}>{MilestoneCollaborationStatusLabel[filterVal]}</span>)
                            }
                        </div>
                    </div>
                    <div className="form-group filter-item">
                        <span className="filter-title">Assignee</span>
                        <div className="d-flex  gap-2 justify-content-start align-items-center flex-wrap">
                            <span onClick={() => handleFilterChange('assignee', '')} className={`filters-badge  d-flex gap-1 align-items-center ${!filters.assignee && 'active'}`}>All</span>
                            {
                                Object.values(MilestoneStepAssignee).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('assignee', filterVal)} className={`filters-badge  d-flex gap-1 align-items-center ${filters.assignee === filterVal && 'active'}`}> <span className={`color-block bg-${MilestoneStepAssigneeColorCode[filterVal]}`}></span> {MilestoneStepAssigneeLabel[filterVal]}</span>)
                            }
                        </div>
                    </div>
                    <div className="form-group filter-item">
                        <span className="filter-title">Has Started?</span>
                        <div className="d-flex  gap-2 justify-content-start align-items-center flex-wrap">
                            {
                                ['y', 'n'].map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('has_processed_steps', filterVal)} className={`filters-badge ${filters.has_processed_steps === filterVal && 'active'}`}>{filterVal === 'y' ? 'Yes' : 'No'}</span>)
                            }
                        </div>
                    </div>
                    {/* <div className="form-group filter-item">
                        <span className="filter-title">Gig Type</span>
                        <select className='form-select ' value={filters.gig_type ?? ''} onChange={(e) => handleFilterChange('gig_type', e.target.value)}>
                            <option value="">Select</option>
                            {
                                gigTypes.map((gigType, i) => <option key={i} value={gigType.slug}>{gigType.name}</option>)
                            }
                        </select>
                    </div> */}
                    {/* <div className="form-group filter-item">
                        <span className="filter-title">Pending Task</span>
                        <select className='form-select ' value={filters.gig_step ?? ''} onChange={(e) => handleFilterChange('gig_step', e.target.value)}>
                            <option value="">Select</option>
                            {
                                gigSteps.map((gigStep, i) => <option key={i} value={gigStep.slug}>{gigStep.name}</option>)
                            }
                        </select>
                    </div> */}
                    <div className="form-group filter-item">
                        <span className="filter-title">Pending Task</span>
                        <AsyncSelect
                            value={typeof filters.gig_step_obj === 'string' ? null : filters.gig_step_obj ?? null}
                            onChange={(val) => {
                                setFilters({ ...filters, gig_step_obj: val ?? null, gig_step: val?.value })
                            }}
                            placeholder="Choose Pending Task"
                            menuPlacement='top'
                            cacheOptions
                            className=''
                            isClearable
                            loadOptions={loadPendingTasksSuggestions}
                            noOptionsMessage={() => "Search Pending Tasks..."}
                        />
                    </div>
                    {/* <div className="d-flex flex-column">
                        <span className="filter-title">Sort By</span>
                        <div className="d-flex  gap-2 justify-content-start align-items-center flex-wrap">
                            {
                                Object.values(MilestoneCollaborationSortOptions).map((filterVal, i) => <span key={i} onClick={() => handleFilterChange('sort', filterVal)} className={`filters-badge ${filters.sort === filterVal && 'active'}`}>{MilestoneCollaborationSortOptionLabel[filterVal]}</span>)
                            }
                        </div>
                    </div> */}
                </div>
                <div className="filters-offcanvas-footer d-flex justify-content-between align-items-center px-3 p-4 gap-2">
                    <button className="theme-btn theme-btn-lg w-100 btn-primary-outlined"
                        onClick={() => {
                            onApply(defaultFiltersValue);
                            onClose();
                        }}
                    >Reset</button>
                    <button className='theme-btn theme-btn-lg w-100 btn-primary' onClick={() => {
                        onApply(filters)
                        onClose();
                    }}>Apply</button>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    )
}

export default TaskFilters